import { Divider } from 'antd';
import { Datagrid } from 'components';
import { useTranslation } from 'react-i18next';
import { ToolMaintenance } from 'app/types/tool';
import { ToolCleaningType, ToolFilterState } from 'constants/tool';

const MaintenanceInfo = ({ maintenance }: { maintenance: ToolMaintenance }) => {
  const { t } = useTranslation();

  const tags = [
    { key: 'CleaningType', value: ToolCleaningType.Wet, color: 'blue', message: t('entities.maintenance.wet') },
    { key: 'CleaningType', value: ToolCleaningType.Dry, color: 'default', message: t('entities.maintenance.dry') },
    { key: 'CleaningType', value: ToolCleaningType.WetAndDry, color: 'blue', message: t('entities.maintenance.wet') },
    { key: 'CleaningType', value: ToolCleaningType.WetAndDry, color: 'default', message: t('entities.maintenance.dry') },
    { key: 'CleaningType', value: ToolCleaningType.NoInfo, color: 'warning', message: t('entities.maintenance.noinfo') },

    { key: 'FilterState', value: ToolFilterState.New, color: 'success', message: t('entities.maintenance.filterstates.new') },
    { key: 'FilterState', value: ToolFilterState.Old, color: 'warning', message: t('entities.maintenance.filterstates.old') },
    { key: 'FilterState', value: ToolFilterState.None, color: 'default', message: t('entities.maintenance.filterstates.none') },

    { key: 'IsElectricalCheckDone', value: true, color: 'success', message: t('common.yes') },
    { key: 'IsElectricalCheckDone', value: false, color: 'default', message: t('common.no') },

    { key: 'IsMechanicalCheckDone', value: true, color: 'success', message: t('common.yes') },
    { key: 'IsMechanicalCheckDone', value: false, color: 'default', message: t('common.no') },

    { key: 'IsWorking', value: true, color: 'success', message: t('common.yes') },
    { key: 'IsWorking', value: false, color: 'error', message: t('common.no') },
  ];

  return (
    <>
      <Datagrid
        data={maintenance}
        keys={[ 'ExecutedAt', 'ExecutorName', 'CompanyName', 'CleaningType', 'FilterState', 'FilterSerialNumber', 'IsElectricalCheckDone', 'IsMechanicalCheckDone', 'IsWorking' ]}
        tags={tags}
        translationsNamespace={'entities.maintenance'} />
      <>
        <Divider orientation='left'>{t('entities.maintenance.comments')}</Divider>
        <Datagrid
          data={maintenance}
          keys={[ 'Comments' ]}
          translationsNamespace={'entities.maintenance'} />
      </>
    </>
  );
};

export default MaintenanceInfo;
